import React from "react";
import "./HotelNotFound.css";
import { Link } from "react-router-dom";


const HotelNotFoundMessage = ({hotelMessage}) => {
  return (
    <div className="noResultsContainer">
      <img src="/Images/browser.png" alt="No Results" className="noResultsIcon" />
      <p className="noResultsText">
        {/* <strong>No more matching properties found with your search/filter criteria.</strong> */}
        <strong>{hotelMessage}</strong>
      </p>
      <div className="noResultsActions">
        {/* <a href="#" className="resetFilters">Reset all Filters</a> */}
        {/* <span className="divider">|</span> */}
        <Link to="/hotelmodify" className="modifySearch">Modify Search</Link>
      </div>
    </div>
  );
};

export default HotelNotFoundMessage;
